import { render, staticRenderFns } from "./finscrapcostshareimp.vue?vue&type=template&id=95ab13da&scoped=true&"
import script from "./finscrapcostshareimp.vue?vue&type=script&lang=js&"
export * from "./finscrapcostshareimp.vue?vue&type=script&lang=js&"
import style0 from "./finscrapcostshareimp.vue?vue&type=style&index=0&id=95ab13da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ab13da",
  null
  
)

export default component.exports